import { Controller } from "stimulus"
import Swiper, { Autoplay } from 'swiper';

// 用在首頁上方的banner
export default class extends Controller {
  static targets = ['swiper']

  swiper = null

  connect() {
    this.swiper = new Swiper(this.swiperTarget, {
      modules: [ Autoplay ],
      direction: 'horizontal',
      lazy: {
        loadPrevNext: true,
      },
      loop: true,
      slidesPerView: 1,
      centeredSlides: true,
      autoplay: {
        delay: 4500,
        disableOnInteraction: false,
      }
    });
  }
  disconnect() {
    this.swiper.destroy()
    this.swiper = null
  }
  clickBtn(e) {
    e.preventDefault()

    // 找到最近的 label 元素
    const label = e.target.closest('label');
    if (!label) return;

    // 通過 label 的 for 屬性找到對應的 input
    const inputId = label.getAttribute('for');
    const input = document.getElementById(inputId);

    if (input) {
      input.checked = !input.checked;
    }
  }
}
